import { useQuery } from '@tanstack/react-query';

import type {
  HealthSnapshot,
  PerformanceDateRange,
  PropertyEvidence,
} from '~/pages/CommercialOps/LPCOfferHealth/types';

import { request } from '~/services/common';

import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

const PATH = '/api/reporting/lpc-offer-health';
const KEY = ['reporting', 'lpc-offer-health'] as const;

export function useLpcOfferHealth(range?: Partial<PerformanceDateRange>, enabled = true) {
  return useQuery<HealthSnapshot>({
    queryKey: [...KEY, range?.start_date, range?.end_date],
    queryFn: ({ signal }) => {
      const query = rangeQuery(range);
      return request(resolveReportingLeLensUrl(`${PATH}${query.size ? `?${query}` : ''}`), { signal });
    },
    enabled,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

function rangeQuery(range?: Partial<PerformanceDateRange>) {
  const query = new URLSearchParams();
  if (range?.start_date != null) query.set('start_date', range.start_date);
  if (range?.end_date != null) query.set('end_date', range.end_date);
  return query;
}

export function useLpcPropertyEvidence(propertyId: string | null, snapshotId?: string, range?: PerformanceDateRange) {
  return useQuery<PropertyEvidence>({
    queryKey: [...KEY, 'property', snapshotId, propertyId, range?.start_date, range?.end_date],
    queryFn: ({ signal }) => {
      const query = rangeQuery(range);
      query.set('snapshot_id', snapshotId!);
      return request(resolveReportingLeLensUrl(`${PATH}/properties/${encodeURIComponent(propertyId!)}?${query}`), { signal });
    },
    enabled: Boolean(propertyId && snapshotId),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
